// components/AccountPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AccountPage() {
  const navigate = useNavigate();
  const [name, setName] = useState(localStorage.getItem("name") || "");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [phone, setPhone] = useState(localStorage.getItem("phone") || "");

  // فرض کنیم api تغییر اطلاعات اینطوریه:
  // /api/account/update  { name, email, phone } با متد POST

  const [message, setMessage] = useState("");

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('access_token');
      const res = await fetch("/api/account/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ name, email, phone }),
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem("name", name);
        localStorage.setItem("email", email);
        localStorage.setItem("phone", phone);
        setMessage("اطلاعات با موفقیت ذخیره شد.");
      } else {
        setMessage("مشکلی پیش آمد: " + (data.message || ""));
      }
    } catch {
      setMessage("ارتباط با سرور برقرار نشد.");
    }
  };

  return (
    <div style={{
      maxWidth: 400,
      margin: "50px auto",
      padding: 20,
      border: "1px solid #eee",
      borderRadius: 12,
      boxShadow: "0 0 10px rgba(0,0,0,0.05)",
      fontFamily: "Vazir, sans-serif",
    }}>
      <h2 style={{textAlign: "center"}}>مدیریت حساب کاربری</h2>
      <form onSubmit={handleSave}>
        <label>نام:</label>
        <input value={name} onChange={e=>setName(e.target.value)} style={{width:"100%",marginBottom:12}} />
        <label>ایمیل:</label>
        <input value={email} onChange={e=>setEmail(e.target.value)} style={{width:"100%",marginBottom:12}} />
        <label>شماره موبایل:</label>
        <input value={phone} onChange={e=>setPhone(e.target.value)} style={{width:"100%",marginBottom:12}} />
        <button type="submit" style={{width:"100%"}} onClick={() => {navigate("/");}}>ذخیره</button>
      </form>
      {message && <div style={{color: "green", marginTop: 15, textAlign: "center"}}>{message}</div>}
    </div>
  );
}
export default AccountPage;
